import React from "react";

export const Onglets = ({  }) => {
    return (

    <div id="expertise" className="slider-services-wrapper" data-scroll-index="2">
        <div className="slider-box-content box-up clearfix">
            <div className="row no-gutters">
                <div className="col-md-3">
                    <div className="slider-services-box b-right b-bottom">
                        <a href="/engineering">
                            <div className="slider-services-box-info">
                                <img src="/assets/images/icons/oiseau.png" className="services-icon" alt=""/>
                                <h5>Ingénierie écologique & <br/> Expertise naturaliste</h5>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="slider-services-box b-bottom">
                        <a href="/impact-study">
                            <div className="slider-services-box-info">
                                <img src="/assets/images/icons/doc.png" className="services-icon" alt=""/>
                                <h5>Etude d’impact & <br/> autres réglementations</h5>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="slider-services-box b-left b-bottom">
                        <a href="/strategy">
                            <div className="slider-services-box-info">
                                <img src="/assets/images/icons/illustration-4.png" className="services-icon" alt=""/>
                                <h5>Stratégie d’entreprise & <br/> Conduite du changement</h5>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="slider-services-box b-left b-right b-bottom">
                        <a href="/transmission">
                            <div className="slider-services-box-info">
                                <img src="/assets/images/icons/transmission.png" className="services-icon" alt=""/>
                                <h5>Transmission & <br/> Animation</h5>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
